export const applicationIdRegExp = /^[a-z0-9]+(-[a-z0-9]+)*$/;

export const emailRegExp = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

export const emailFromUserInfoRegExp = /\((.*?)\)/;
